export default __webpack_public_path__ + "36b47d45ced7277cd4190add81c18b37.jpg";